<script>
import BubbleNav from "./BubbleNav.vue";
import SidebarAdminPanel from "./SidebarAdminPanel.vue";

export default {
    components: {BubbleNav, SidebarAdminPanel},
    data() {

    }
}
</script>

<template>

    <div>
        <BubbleNav></BubbleNav>
        <SidebarAdminPanel></SidebarAdminPanel>
    </div>

</template>
